module.exports = __webpack_public_path__ + "static/img/jt4.baec905.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/jt4.jpg
// module id = 1kIS
// module chunks = 1